var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.open,
        size: "lg",
        title: "How to build your query",
        "hide-footer": "",
        scrollable: "",
        "body-class": "pt-2 pb-3",
      },
      on: {
        change: function ($event) {
          return _vm.$emit("update:open", $event)
        },
      },
    },
    [_c("workflow-query-guidelines")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }